import { checkOwnershipByID } from "~/services/chekcProduct"

export const isOwner = async () => {
  const owner = await checkOwnershipByID({ productID: "63d6701a1ee1322b4efc1bb7" })
  return owner.data !== null
}
